// TODO Remove after implementing Stripe v3
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProfilePriceFilterPipe } from '@pipes/profile-price-filter/profile-price-filter';
import { AccountServiceProvider } from '@services/user/account.service';
import { User } from '@models/models';
import { Subscription } from 'rxjs';

@Component({
	selector: 'subscription-annual-discount',
	template: require('./subscription-annual-discount.html')
})
export class SubscriptionAnnualDiscountWebComponent
	implements OnInit, OnDestroy {
	user: User;
	userObservable: Subscription;
	billFull: string;
	coinFull: string;
	bill: string;
	coin: string;
	label: string;

	constructor(
		private accountService: AccountServiceProvider,
		private profilePricePipe: ProfilePriceFilterPipe
	) {}

	ngOnInit() {
		this.getUser();
	}

	ngOnDestroy() {
		this.userObservable.unsubscribe();
	}

	private setAnnualPrice(): void {
		if (this.user && this.user.subscriptionPrice) {
			const prices = this.user.subscriptionPrice;

			this.billFull = this.profilePricePipe.transform(
				prices.annualPrice,
				'bill'
			);
			this.coinFull = this.profilePricePipe.transform(
				prices.annualPrice,
				'coin'
			);

			this.bill = this.profilePricePipe.transform(
				prices.annualDiscountPrice,
				'bill'
			);
			this.coin = this.profilePricePipe.transform(
				prices.annualDiscountPrice,
				'coin'
			);

			this.label = this.profilePricePipe.transform(prices.annualPrice, 'label');
		}
	}

	private getUser() {
		this.userObservable = this.accountService.userDataObservable.subscribe(
			user => {
				if (user !== null && typeof user !== 'undefined') {
					this.user = JSON.parse(JSON.stringify(user));
					this.setAnnualPrice();
				}
			}
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/subscription/subscription-elements/subscription-annual-discount/subscription-annual-discount.ts